import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Searchable select (Tom Select). A select with the readonly attribute (e.g.
// the category of an edited record) is shown but can't be changed.
export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {
      maxOptions: null,
      // search box inside the dropdown, the field itself shows the chosen value
      plugins: ["dropdown_input"],
      render: { no_results: () => '<div class="no-results">Nie znaleziono pozycji</div>' }
    })
    if (this.element.hasAttribute("readonly")) this.tomSelect.lock()
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
